(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.rv-form');
    const quantity = form.querySelector('[name="quantity"]');
    const mist = form.querySelector('[data-mist]');
    const mistVariant = form.querySelector('[data-mist-variant]');
    const mistPrice = form.querySelector('.rv-upsell-price');
    const submit = form.querySelector('[type="submit"]');
    const label = submit.querySelector('[data-atc-label]');
    const error = form.querySelector('[data-error-message]');
    const money = new Intl.NumberFormat(root.dataset.locale || 'en-GB', {style: 'currency', currency: root.dataset.currency || 'GBP'});
    const track = root.querySelector('.rv-track');
    const thumbs = [...root.querySelectorAll('[data-slide]')];
    let busy = false;
    const pairSelected = () => Boolean(mist && mist.checked && !mist.disabled);
    function update() {
      if (submit.disabled && !busy) return;
      if (mist && mistVariant) {
        const option = mistVariant.selectedOptions[0];
        mist.value = option.value;
        root.dataset.mistPrice = option.dataset.price;
        mistPrice.textContent = '+' + money.format(Number(option.dataset.price) / 100);
      }
      const count = Math.max(1, Number(quantity.value) || 1);
      const total = Number(root.dataset.oilPrice) * count + (pairSelected() ? Number(root.dataset.mistPrice) : 0);
      label.textContent = `${pairSelected() ? root.dataset.addBoth : root.dataset.add} · ${money.format(total / 100)}`;
    }
    const pairLink = root.querySelector('.rv-pair-cta');
    if (pairLink) pairLink.addEventListener('click', () => {
      if (mist && !mist.disabled) { mist.checked = true; update(); }
    });
    quantity.addEventListener('input', update);
    if (mist) mist.addEventListener('change', update);
    if (mistVariant) mistVariant.addEventListener('change', update);
    thumbs.forEach((button, index) => button.addEventListener('click', () => {
      track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }, {passive: true});
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || submit.disabled || !form.reportValidity()) return;
      const items = [{id: Number(form.querySelector('[name="id"]').value), quantity: Number(quantity.value)}];
      if (pairSelected()) items.push({id: Number(mist.value), quantity: 1});
      busy = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      quantity.disabled = true;
      if (mist) mist.disabled = true;
      if (mistVariant) mistVariant.disabled = true;
      error.hidden = true;
      label.textContent = root.dataset.adding;
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || root.dataset.error);
        if (!window.twCartOpen) window.location.assign(base + 'cart');
      } catch (err) {
        error.textContent = err.message || root.dataset.error;
        error.hidden = false;
      } finally {
        busy = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        quantity.disabled = false;
        if (mist && !mist.closest('.rv-unavailable')) mist.disabled = false;
        if (mistVariant) mistVariant.disabled = false;
        update();
      }
    });
  }
  document.querySelectorAll('[data-revive]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-revive]').forEach(init));
})();
